import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { Valence } from '@upright/common/model/types';
import { Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { LensSelectionStates } from '../../selection-hook';
import { ImpactLensType } from '@upright/common/impact-lenses/types';

type TargetLensSelectionState = LensSelectionStates[ImpactLensType.TARGETS];

export function onTargetDataClick(
  state: TargetLensSelectionState,
  setState: (newState: TargetLensSelectionState) => void,
  impactId: ImpactCategoryId,
  valence: Valence,
) {
  if (valence === Valence.OTHER) {
    console.error('Impact Lens Profile state cannot be set to "other valence".');
  }

  if (valence === Valence.NEGATIVE) {
    if (state.left === impactId) {
      setState({ ...state, left: undefined, lastSide: undefined });
    } else {
      setState({ ...state, left: impactId, lastSide: Side.LEFT });
    }
  }
  if (valence === Valence.POSITIVE) {
    if (state.left === impactId) {
      setState({ ...state, right: undefined, lastSide: undefined });
    } else {
      setState({ ...state, right: impactId, lastSide: Side.RIGHT });
    }
  }
}

export function isTargetHighLighted(state: TargetLensSelectionState, impactId: ImpactCategoryId, valence: Valence) {
  switch (valence) {
    case Valence.NEGATIVE:
      return state.left === impactId;
    case Valence.POSITIVE:
      return state.right === impactId;
    default:
      throw Error(`Unknown valence ${valence} for impact bar.`);
  }
}
